import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "mobx-react";
import './index.scss';
import { App } from './scenes';
import * as serviceWorker from './serviceWorker';
import RootStore from './stores';

const Root = RootStore.create({});

ReactDOM.render(
  <Provider
    TeamsStore={Root.TeamsStore}
    UserStore={Root.UserStore}
    SitesStore={Root.SitesStore}
    ClubsStore={Root.ClubsStore}
    CoachesStore={Root.CoachesStore}
    VideosStore={Root.VideosStore}
    MetricsStore={Root.MetricsStore}
    CategoriesStore={Root.CategoriesStore}
    NotificationsStore={Root.NotificationsStore}
    MetaStore={Root.MetaStore}
  >
    <App />
  </Provider>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
